/* eslint-disable */

import { StyleSheet } from 'aphrodite'
import React, { useState } from 'react'
import { useLoad } from "../../hooks/request";
import { useQueryParams } from "../../hooks/queryString";
import Button from "../../components/common/Button";
import { useModal } from "../../hooks/modal";
import Layout from "../../components/Layout";
import { CUSTOMER_LIST } from "../../urls";
import CustomerCreate from "./CustomerCreate";
import BuildingTabs from "../../components/BuildingTabs";
import Table from "../../components/common/Table";
import CustomerItem from "./CustomerItem";


export default function Customer() {
    const [page, setPage] = useState(1)
    const [params, setParams] = useState({})

    const searchParam = useQueryParams()
    const customer = useLoad({
        url: CUSTOMER_LIST,
        params: { page, ...params, ...searchParam }
    }, [searchParam, page, params])

    const productList = customer.response ? customer.response.results : []
    const [showCreateModal, setShowCreateModal] = useModal(<CustomerCreate expenseReport={customer}
                                                                           onCancel={() => setShowCreateModal()}/>, styles.modal)

    return (
        <Layout showCreateModal={showCreateModal}>
            <div className="is-flex is-justify-content-space-between mb-3 is-align-items-center">
                <h2 className="title is-size-4">Мижозлар</h2>
                <Button text="Қўшиш" className="button is-link is-outlined" onClick={showCreateModal}/>
            </div>
            <BuildingTabs/>
            <div>
                <div className="mt-4 mb-4">
                    <Table
                        loading={customer.loading}
                        items={productList}
                        columns={{
                            index: '№',
                            datae: 'Мижоз номи',
                            dd32date: 'Телефон рақам',
                            dbuttons: ''
                        }}
                        totalCount={customer.response ? customer.response.count : 0}
                        activePage={page}
                        onPageChange={setPage}
                        renderItem={(item, index) =>
                            <CustomerItem
                                customer={customer}
                                index={index}
                                key={item.id}
                                item={item}/>}
                    />
                </div>
            </div>
        </Layout>
    )
}

const styles = StyleSheet.create({
    space: { marginTop: '2rem' },
    emptyImg: { width: '330px', height: '300px' },
    loader: { marginTop: '2rem' },
    modal: { width: 800 },
    checkmark: { marginRight: '3px' },
})
